(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service(
      'checkAccessRefreshTokenValidity',
      checkAccessRefreshTokenValidityService
    );

  /** @ngInject */
  function checkAccessRefreshTokenValidityService(
    sessionData,
    jwtHelper,
    $http,
    hostDomain,
    hostProtocol,
    $log,
    $timeout,
    $state,
    checkUserRole,
    helperService
  ) {
    this.refreshToken = function () {
      var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY),
        refreshToken = sessionData.getValue(sessionData.Keys.REFRESH_TOKEN_KEY);

      if (token && refreshToken) {
        var isTokenExpired = jwtHelper.isTokenExpired(token, 1),
          isRefreshTokenExpired = jwtHelper.isTokenExpired(refreshToken, 1);

        if (isTokenExpired && !isRefreshTokenExpired) {
          $http({
            method: 'PUT',
            cache: false,
            async: false,
            url: hostProtocol + '://' + hostDomain + '/api/refreshToken',
            headers: {
              Accept: 'text/plain, application/vnd.authentication.v2+json'
            },
            data: refreshToken
          }).then(
            function (successData) {
              helperService.setUserDataToLocalStorageOnLogIn(successData.data);
              if (checkUserRole.hasAcceptNewTerms(successData.data.roles)) {
                $state.go('app.termsAndService', {
                  marker: 'ready2wash-terms-of-service'
                });
              } else {
                sessionData.setValue(
                  sessionData.Keys.ACCESS_TOKEN_KEY,
                  successData.data.accessToken
                );
                $state.reload();
              }
            },
            function (errorData) {
              $log.error(errorData);
              sessionData.clearAll();
              $state.go('login');
            }
          );
        } else {
          $timeout(function () {
            sessionData.clearAll();
            $state.go('login');
          });
        }
      }
    };
  }
})();
